import React from 'react';
import './GarminAttribution.css';

interface GarminAttributionProps {
  theme?: 'light' | 'dark';
  size?: 'small' | 'medium';
  className?: string;
  deviceModel?: string | null; // For "Garmin [device model]" compliance
}

/**
 * Garmin Brand Compliance Component
 * 
 * Per Garmin API Brand Guidelines (v 6.30.2025):
 * - All uses of Garmin device-sourced data MUST include attribution
 * - Format: "Garmin [device model]" or Garmin tag logo + device model
 * - Attribution must be visible, never buried in tooltips or expandable containers
 * - Device model information should be accessed from API when available
 * 
 * Usage:
 * - Connection screens: <GarminAttribution theme="light" />
 * - Activity displays: <GarminAttribution deviceModel="Forerunner 945" theme="light" />
 */
export const GarminAttribution: React.FC<GarminAttributionProps> = ({ 
  theme = 'light', 
  size = 'medium',
  className = '',
  deviceModel = null
}) => {
  const logoSrc = theme === 'dark' 
    ? '/garmin-assets/Garmin Tag-white-high-res.png'
    : '/garmin-assets/Garmin Tag-black-high-res.png';
  
  // Fallback paths for older deployments
  const fallbackSrc = theme === 'dark'
    ? '/garmin-tag-white.png'
    : '/garmin-tag-black.png';

  return (
    <div className={`garmin-attribution ${theme} ${size} ${className}`}>
      <img 
        src={logoSrc}
        alt="Garmin"
        className="garmin-attribution-logo"
        onError={(e) => {
          e.currentTarget.src = fallbackSrc;
        }}
      />
      {deviceModel && (
        <span className="garmin-device-model">{deviceModel}</span>
      )}
    </div>
  );
};

